module.exports = __webpack_public_path__ + "img/图片2.687c43b8.png";